<template>
  <v-autocomplete
      class="category-select"
      :value="viewValue"
      @input="handleInput"
      :items="categories"
      item-text="name"
      item-value="id"
      :return-object="false"
      :clearable="clearable"
      :dense="dense"
      :disabled="disabled"
      :outlined="outlined"
      :rounded="rounded"
      :label="label"
      :placeholder="placeholder"
      :readonly="readonly"
      :rules="rules"
      :multiple="multiple"
      :light="light"
      :dark="dark"
      :chips="chips"
      deletable-chips
      :small-chips="smallChips"
      :color="color"
      :background-color="backgroundColor"
      :hide-details="hideDetails">
    <template #item="{item}">
      <el-popover
          trigger="hover"
          title="説明"
          :content="item.description"
          width="400"
          :placement="popoverPlacement"
          :open-delay="300"
          :close-delay="50">
        <template slot="reference">
          <span>{{ item.name }}</span>
        </template>
      </el-popover>
    </template>
  </v-autocomplete>
</template>

<script>
import natsort from "natsort";
import {mapGetters} from "vuex";

const sortFn = natsort();

export default {
  name: 'CategorySelect',
  props: {
    value: [String, Number, Array],
    categoryIds: Array,
    readonly: Boolean,
    rules: Array,
    multiple: Boolean,
    clearable: Boolean,
    dense: Boolean,
    disabled: Boolean,
    outlined: Boolean,
    rounded: Boolean,
    placeholder: String,
    label: String,
    light: Boolean,
    dark: Boolean,
    chips: Boolean,
    smallChips: Boolean,
    color: String,
    backgroundColor: String,
    hideDetails: Boolean,
    popoverPlacement: {
      type: String,
      default: 'right'
    }
  },
  computed: {
    ...mapGetters({
      entities: 'hds/entities'
    }),
    viewValue() {
      if (Array.isArray(this.value)) {
        return this.entities.category.find({id: {$in: this.value}})
            .sort((a, b) => sortFn(a.name, b.name))
            .map(c => c.id);
      }
      return this.value;
    },
    categories() {
      const grouped = new Map();
      const query = this.categoryIds ? {id: {$in: this.categoryIds}} : undefined;
      const categories = this.entities.category.find(query);
      for (let c of categories) {
        const genre = c.genre;
        if (grouped.has(genre)) {
          grouped.get(genre).push(c);
        } else {
          grouped.set(genre, [c]);
        }
      }

      const result = [];
      Array.from(grouped.entries())
          .map(([genre, categories]) => {
            if (!genre) {
              genre = "\u200Bジャンル指定無し";
            }
            return [genre, categories];
          })
          .sort((a, b) => sortFn(a[0], b[0]))
          .forEach(([genre, categories], index) => {
            categories.sort((a, b) => sortFn(a.name, b.name));
            if (index > 0) {
              result.push({divider: true});
            }
            result.push({header: genre});
            result.push(...categories);
          });
      return result;
    },
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value);
    }
  }
}
</script>
